import { request } from '@/apis/request'

const PRE_PATH = '/v1/sys'

export const getMenusButtons = (params) => {
  return request({
    url: `${PRE_PATH}/menu`,
    method: 'get',
    params: params,
    rd: true
  })
}

export const getMenusButtonsByRole = () => {
  return request({
    url: `${PRE_PATH}/sysUser/menusAndButtons`,
    method: 'get',
    rd: true
  })
}

export function deleteButton(buttonNo) {
  return request({
    url: `${PRE_PATH}/button/${buttonNo}`,
    method: 'delete',
    rd: true
  })
}

export function deleteMenu(menuNo) {
  return request({
    url: `${PRE_PATH}/menu/${menuNo}`,
    method: 'delete',
    rd: true
  })
}

export function updateButton(buttonNo, data) {
  return request({
    url: `${PRE_PATH}/button/${buttonNo}`,
    method: 'post',
    data: data,
    rd: true
  })
}

export function checkMenuOrder(data) {
  return request({
    url: `${PRE_PATH}/menu/order`,
    method: 'post',
    data: data,
    rd: true
  })
}

export function updateMenu(menuNo, data) {
  return request({
    url: `${PRE_PATH}/menu/${menuNo}`,
    method: 'post',
    data: data,
    rd: true
  })
}

export const checkMenuCode = (data, hideLoading) => {
  return request({
    url: `${PRE_PATH}/menu/code`,
    method: 'post',
    data: data,
    rd: true,
    hideLoading
  })
}
export const checkMenuName = (data) => {
  return request({
    url: `${PRE_PATH}/menu/name`,
    method: 'post',
    data: data,
    rd: true
  })
}
export const checkButtonCode = (data) => {
  return request({
    url: `${PRE_PATH}/button/code`,
    method: 'post',
    data: data,
    rd: true
  })
}
export const checkButtonName = (data) => {
  return request({
    url: `${PRE_PATH}/button/name`,
    method: 'post',
    data: data,
    rd: true
  })
}
export const getMaxOrder = (params) => {
  return request({
    url: `${PRE_PATH}/menu/maxMenuOrder`,
    method: 'get',
    params: params,
    rd: true
  })
}
export const addMenu = (data) => {
  return request({
    url: `${PRE_PATH}/menu`,
    method: 'post',
    data: data,
    rd: true
  })
}
export const addButton = (data) => {
  return request({
    url: `${PRE_PATH}/button`,
    method: 'post',
    data: data,
    rd: true
  })
}
export const getRoleMenusButtons = (rolePlatformNo) => {
  return request({
    url: `${PRE_PATH}/menu/roleMenuAndButtons?rolePlatformNo=${rolePlatformNo}`,
    method: 'get',
    rd: true
  })
}


export const getAllMenus = () => {
  return request({
    url: `/v1/sys/menu`,
    method: 'get',
  })
}
